<template>
  <div class="notfount">
    亲，您访问的页面不存在
  </div>
</template>

<script>
export default {
  metaInfo: { title: "访问错误" },
  name: "notfount",
};
</script>

<style lang="less" scoped>
</style>